import './DetailItem.css';

import { IonCol, IonIcon, IonItem, IonRow, IonText } from '@ionic/react';
import { Link } from 'react-router-dom';

interface Props {
    icon: string,
    title: any,
    subtitle?: any,
    passed: boolean,
    active?: boolean
}

const DetailItem: React.FC<Props> = (props) => {
    let classNames = ["order-detail-item"];

    if (props.active) {
        classNames.push("active");
    } else if (props.passed) {
        classNames.push("passed");
    }

    return <div className={classNames.join(" ").toString()}>
        <IonRow>
            <IonCol size="2"></IonCol>
            <IonCol size="10">
                <div>
                    <div className="title" dangerouslySetInnerHTML={{ __html: props.title }}></div>
                    {props.subtitle ? <div className="subtitle" dangerouslySetInnerHTML={{ __html: props.subtitle }}></div> : null}
                </div>
            </IonCol>
        </IonRow>
        <>
            <div className="lines">
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zm.287 5.984l-3 3a.5.5 0 0 1-.708" />
                </svg>
                <IonIcon className="icon" icon={props.icon} />
            </div>
        </>
    </div>
}

export default DetailItem